const initFaqShowButton = () => {
  const button = document.querySelector('.faq__button');
  const hiddenFaqs = document.querySelectorAll('.faq__question.is-hidden');
  if (!button) return;

  const onButtonClick = () => {
    hiddenFaqs.forEach(faq => faq.classList.remove("is-hidden"));
    button.remove();
  };

  button.addEventListener('click', onButtonClick);
};

export default initFaqShowButton;
